module.exports = __webpack_public_path__ + "static/media/external_env_2_media_1.65230f07.webp";